
const tokenDefinition = ({name, type, tokenMatcher, contentMatcher }) => ({
    name,
    type,
    tokenMatcher,
    contentMatcher
})

export {tokenDefinition}